import React from 'react';
import { Flex, Button, message, Tabs, Modal, Divider } from 'antd';
import TemplateList from './template-list';
import DraftList from './draft-list';
import MiniList from './mini-list';

export default () => {
    const getQRcode = async (accId = '') => {
        Modal.info({icon: null, content: <div style={{textAlign: 'center'}}><p>微信扫码进入体验版</p><img width={160} src={`/api/sys/mini-trial-code?accId=${accId}`} /></div>});
    };

    const generateAllVersion = async () => {
        const loading = message.loading('正在生成，请稍后...');
        const res = await fetch('/api/sys/generate-all-version', {method: 'POST'});
        const data = await res.json();

        message.destroy(loading);

        if (data?.success) {
            message.success('生成成功');
            Modal.success({
                title: '生成结果',
                content: (
                    <div>
                        {JSON.stringify(data.data)}
                    </div>
                ),

            })
        } else {
            message.error(data.message);
        }
    };

    const submitAllAudit = async () => { 
        const loading = message.loading('提交中，请稍后...');
        const res = await fetch('/api/sys/submit-all-audit', {method: 'POST'});
        const data = await res.json();

        message.destroy(loading);

        if (data?.success) {
            message.success('生成成功');
        } else {
            message.error(data.message);
        }
    };

    const releaseAll = async () => { 
        const loading = message.loading('发布中，请稍后...');
        const res = await fetch('/api/sys/release-all', {method: 'POST'});
        const data = await res.json();

        message.destroy(loading);

        if (data?.success) {
            message.success('发布成功');
        } else {
            message.error(data.message);
        }
    };

    const modifyServerDomain = async () => {
        const loading = message.loading('正在修改，请稍后...');
        const res = await fetch('/api/sys/modify-server-domain', {method: 'POST'});
        const data = await res.json();

        message.destroy(loading);

        if (data?.success) {
            message.success('修改成功');
        } else {
            message.error(data.message);
        }
    }

    const modifyJumpDomain = async () => {
        const loading = message.loading('正在修改，请稍后...');
        const res = await fetch('/api/sys/modify-jump-domain', {method: 'POST'});
        const data = await res.json();

        message.destroy(loading);

        if (data?.success) {
            message.success('修改成功');
        } else {
            message.error(data.message);
        }
    }

    const setPrivacySetting = async () => {
        const loading = message.loading('正在设置，请稍后...');
        const res = await fetch('/api/wxopen/setprivacysetting?privacy_ver=2');
        const data = await res.json();

        message.destroy(loading);

        if (data?.success) {
            message.success('设置成功');
        } else {
            message.error(data.message);
        }
    }

    return (
        <div>
            <h2>小程序代码管理</h2>
            <Tabs defaultActiveKey="draft" items={[
                {
                    key: 'draft',
                    label: '草稿',
                    children: <DraftList />
                },
                {
                    key: 'template',
                    label: '模板',
                    children: <TemplateList />
                },
                {
                    key: 'mini',
                    label: '小程序',
                    children: <MiniList />

                }
            ]} />
            <h3>小程序分发</h3>
            <Flex gap={15} wrap="wrap" align='center'>
                <Button onClick={generateAllVersion}>1 生成所有体验版</Button>
                <Button onClick={submitAllAudit}>2 提交审核</Button>
                <Button onClick={releaseAll}>3 发布小程序</Button>
                <Button onClick={setPrivacySetting}>4 设置用户隐私</Button>
            </Flex>
            <Divider />
            <p>全局设置：仅有新增小程序的时候设置</p>
            <Flex gap={15} wrap="wrap" align='center'>
                <Button onClick={modifyServerDomain}>设置服务器域名</Button>
                <Button onClick={modifyJumpDomain}>设置业务域名</Button>
            </Flex>
        </div>
    )
}